import React from 'react';
import PropTypes from 'prop-types';

import './FieldCheckboxGroup.sass';

import cx from 'classnames';
import FieldCheckbox from '../fieldCheckbox/FieldCheckbox';

export default function FieldCheckboxGroup({input, meta: {touched, error} = {}, label, className, choices, required}) {
  const displayError = (touched && error);

  return (
    <fieldset className={cx('field-checkbox-group', className)}>
      {label && <legend className="field-checkbox-group__title">{label}</legend>}

      {choices.map(choice => (
        <FieldCheckbox
          key={choice.code}
          name={input.name}
          value={choice.code}
          checked={input.value.includes(choice.code)}
          onChange={evt => input.onChange(evt.target.checked
            ? input.value.concat(choice.code)
            : input.value.filter(it => it !== choice.code)
          )}
          required={required}
        >
          {choice.label}
        </FieldCheckbox>
      ))}

      {displayError && (<div className="field-checkbox-group__error-message">{error}</div>)}
    </fieldset>
  );
}

FieldCheckboxGroup.defaultValue = [];



// WEBPACK FOOTER //
// ./components/fields/fieldCheckboxGroup/FieldCheckboxGroup.js